"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagesSchema = exports.loadDefinitions = exports.Messages = exports.encodeMessage = exports.decodeMessage = exports.parseConfigure = void 0;
const tslib_1 = require("tslib");
const long_1 = tslib_1.__importDefault(require("long"));
const protobuf = tslib_1.__importStar(require("protobufjs/light"));
const decode_1 = require("./decode");
const encode_1 = require("./encode");
const utils_1 = require("./utils");
_a = (() => {
    protobuf.util.Long = long_1.default;
    protobuf.configure();
    return { parseConfigure: utils_1.parseConfigure, decodeMessage: decode_1.decodeMessage, encodeMessage: encode_1.encodeMessage };
})(), exports.parseConfigure = _a.parseConfigure, exports.decodeMessage = _a.decodeMessage, exports.encodeMessage = _a.encodeMessage;
exports.Messages = tslib_1.__importStar(require("./messages"));
var load_definitions_1 = require("./load-definitions");
Object.defineProperty(exports, "loadDefinitions", { enumerable: true, get: function () { return load_definitions_1.loadDefinitions; } });
exports.MessagesSchema = tslib_1.__importStar(require("./messages-schema"));
//# sourceMappingURL=index.js.map